module.exports = __webpack_public_path__ + "img/HardiotIcon.41420174.png";